import { render, staticRenderFns } from "./showdatatorcomponents.vue?vue&type=template&id=40e540c2"
import script from "./showdatatorcomponents.vue?vue&type=script&lang=js"
export * from "./showdatatorcomponents.vue?vue&type=script&lang=js"
import style0 from "./showdatatorcomponents.vue?vue&type=style&index=0&id=40e540c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports